export class PaymentSlip implements IPaymentSlip {
  invoiceNumber = '';
  orderNumber = '';
  invoiceSerieNumber = '';
  finalCustomerDocument: ICompanyDocument | IPersonalDocument = CompanyDocument('');
  finalCustomerName = '';
  paymentInformationOutput: IPaymentInformationOutputList = Array<IPaymentInformationOutput>();
  readonly isPaymentSlip: MySsTypeGuard<IPaymentSlip> = this.isPaymentSlipValidation;

  constructor(paymentSlipDto?: IPaymentSlipDTO) {
    if (paymentSlipDto) {
      this.invoiceNumber = paymentSlipDto.invoiceNumber;
      this.orderNumber = paymentSlipDto.orderNumber;
      this.invoiceSerieNumber = paymentSlipDto.invoiceSerieNumber;
      this.finalCustomerDocument = this.adaptFinalCustomerDocument(paymentSlipDto.finalCustomerDocument);
      this.finalCustomerName = paymentSlipDto.finalCustomerName;
      this.paymentInformationOutput = this.adaptPaymentInformationOutputList(paymentSlipDto.paymentInformationOutput);
    }
  }

  get dto(): IPaymentSlipDTO {
    return {
      invoiceNumber: this.invoiceNumber,
      orderNumber: this.orderNumber,
      invoiceSerieNumber: this.invoiceSerieNumber,
      finalCustomerDocument: this.finalCustomerDocument.unmasked,
      finalCustomerName: this.finalCustomerName,
      paymentInformationOutput: this.adaptPaymentInformationOutputListDto(this.paymentInformationOutput),
    };
  }

  private adaptPaymentInformationOutputList(paymentInformationDtoList: IPaymentInformationOutputDTOList | null): IPaymentInformationOutputList {
    return paymentInformationDtoList
      ? paymentInformationDtoList.map((paymentInformation: IPaymentInformationOutputDTO) =>
        new PaymentInformationOutput(paymentInformation))
      : Array<IPaymentInformationOutput>();
  }

  private adaptPaymentInformationOutputListDto(paymentInformationList: IPaymentInformationOutputList): IPaymentInformationOutputDTOList {
    return paymentInformationList
      ? paymentInformationList.map((paymentInformation: IPaymentInformationOutput) => paymentInformation.dto)
      : Array<IPaymentInformationOutputDTO>();
  }

  private adaptFinalCustomerDocument(documentNumber: string): ICompanyDocument | IPersonalDocument {
    const companyDocument = CompanyDocument(documentNumber);
    const personalDocument = PersonalDocument(documentNumber);

    return companyDocument.isCompanyDocumentLike
      ? companyDocument
      : personalDocument;
  }

  private isPaymentSlipValidation(obj: any): obj is IPaymentSlip {
    return obj instanceof PaymentSlip;
  }
}

export class PaymentInformationOutput implements IPaymentInformationOutput {
  installment: number = 0;
  installmentAmount: string = '';
  installmentDueDate: string = '';
  installmentPaymentDate: string = '';

  constructor(paymentInformationOutputDto?: IPaymentInformationOutputDTO) {
    if (paymentInformationOutputDto) {
      this.installment = paymentInformationOutputDto.installment;
      this.installmentAmount = this.formatCurrency(paymentInformationOutputDto.installmentAmount);
      this.installmentDueDate = this.formatDate(paymentInformationOutputDto.installmentDueDate);
      this.installmentPaymentDate = this.formatDate(paymentInformationOutputDto.installmentPaymentDate);
    }
  }

  get dto(): IPaymentInformationOutputDTO {
    return {
      installment: this.installment,
      installmentAmount: this.formatCurrencyDto(this.installmentAmount),
      installmentDueDate: this.formatDateDto(this.installmentDueDate),
      installmentPaymentDate: this.formatDateDto(this.installmentPaymentDate),
    };
  }

  private formatDate(date: string | null): string {
    return convertToBrDate(date);
  }

  private formatDateDto(date: string): string {
    return convertToIsoDate(date);
  }

  private formatCurrency(value: number): string {
    return convertToBrCurrency(value);
  }

  private formatCurrencyDto(value: string): number {
    return formatBrCurrencyToNumber(value);
  }
}
